export default __webpack_public_path__ + "static/media/wind.8a75e71b.jpg";